import styled, { css } from 'styled-components'

const designerCSS = css`
  position: relative;
  border-radius: 10px 0 0 0;
  top: 70px;
  right: 0;
  overflow: auto;
  width: 100%;
  padding: 56px 0 0 0;
  height: calc(100% - 70px);
  transition: all 500ms ease-in;
  background: var(--side-panel-background);
  backdrop-filter: blur(10px);

  @media (max-width: 1600px) {
    position: absolute;
    top: 70px;
    right: 0;
    height: calc(100% - 70px);
    z-index: 1;
    backdrop-filter: blur(10px);
  }

  @media (min-width: 1601px) {
  }
`

const devCSS = css`
  max-width: ${({ isOpen }) => (isOpen ? '300px' : '50px')};

  @media (max-width: 800px) {
    max-width: ${({ isOpen }) => (isOpen ? '300px' : '30px')};
  }
`

export const Chat = styled.div`
  ${designerCSS}
  ${devCSS}
`
